<template>
  <div class="merchant-business-list">
    <el-table
      v-loading="tableLoading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column prop="name" label="商机名称" align="center">
        <template slot-scope="scope">
          <span class="text-split" :title="scope.row.name">{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="商机金额" align="center">
        <template slot-scope="scope">
          <span
            class="text-split"
            :title="scope.row.amount"
          >￥{{scope.row.amount.toFixed(2) | turnToPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="merchantName" label="公司名称" align="center">
        <template slot-scope="scope">
          <span
            class="text-split"
            :title="scope.row.merchantCompanyName"
          >{{scope.row.merchantCompanyName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="merchantName" label="联系人" align="center">
        <template slot-scope="scope">
          <span class="text-split" :title="scope.row.merchantName">{{scope.row.merchantName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sourceName" label="商机来源" align="center">
        <template slot-scope="scope">
          <span class="text-split" :title="scope.row.sourceName">{{scope.row.sourceName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stageName" label="商机阶段" align="center">
        <template slot-scope="scope">
          <span class="text-split" :title="scope.row.stageName">{{scope.row.stageName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="control" align="center" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            type="warning"
            class="control-btn"
            size="small"
            @click="showBusinessChancesDetail(scope.row)"
          >查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagenation-wrapper" v-if="tableData.length > 0">
      <el-pagination
        class="pagenation"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSizes"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      tableData: [],
      currentId: null,
      page: 0,
      size: 10,
      totalPages: 0,
      totalSizes: 0
    };
  },
  created() {
    if (this.$route.query.id) {
      this.currentId = this.$route.query.id;
      this.getMerchantsBusinessChanceList(this.currentId);
    }
  },
  methods: {
    handleSizeChange(size) {
      this.page = 0;
      this.size = size ? size : this.size;
      this.getMerchantsBusinessChanceList(this.currentId);
    },
    handleCurrentChange(Cpage) {
      this.page = Cpage ? Cpage - 1 : 0;
      this.getMerchantsBusinessChanceList(this.currentId);
    },
    getMerchantsBusinessChanceList(id) {
      this.tableLoading = true;
      this.$api
        .get(`/business_chances`, {
          params: {
            page: this.page,
            size: this.size,
            merchantId: this.currentId
          }
        })
        .then(res => {
          if (res.status === 200 || res.status === 206) {
            let { content, totalPages, totalElements } = res.data;
            this.tableData = content;
            this.totalPages = totalPages;
            this.totalSizes = totalElements;
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error("数据获取失败", err.response);
          this.$notify.error({
            title: "数据拉取错误",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`
          });
        });
    },
    showBusinessChancesDetail(target) {
      this.$router.push({
        path: "/business/chances/detail",
        query: {
          id: target.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.merchant-business-list {
  padding: 0 0;
  .pagenation-wrapper {
    padding: 10px 0;
    border: 1px solid #dbdbdb;
    /deep/ {
      // 页码列表的前后的按钮
      .el-pagination button {
        background-color: transparent;
      }
      .el-pagination button:disabled {
        background-color: transparent;
      }
      .el-pagination button:hover {
        color: #fff;
        background-color: #4c4948;
      }
      // 可选的页码列表
      .el-pager li {
        background-color: transparent;
      }
      .el-pager li:hover {
        color: #fff;
        background-color: #4c4948;
      }
      .el-pager li.active {
        color: #fff;
        background-color: #4c4948;
        cursor: default;
      }
      // 手动输入页数的输入框
      .el-pagination__editor.el-input .el-input__inner {
        background-color: transparent;
      }
      // 选择多少条每页的按钮
      .el-pagination .el-select .el-input .el-input__inner {
        background-color: transparent;
      }
    }
  }
  // 表格样式自定义
  /deep/ {
    .el-table {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #dbdbdb;
      background-color: transparent;
      & ::before,
      & ::after {
        background-color: #dbdbdb;
      }
    }
    .el-table tr {
      background-color: transparent;
      &:hover {
        background-color: transparent;
      }
      &:hover td {
        background-color: transparent;
      }
    }
    .el-table--border {
      border-right-width: 1px;
      border-bottom-width: 1px;
    }
    .el-table--border::after {
      background-color: transparent;
    }
    .el-table th {
      font-weight: normal;
      color: #000;
      background-color: #e7e7e7;
      border-color: #dbdbdb;
    }
    .el-table td {
      background-color: transparent;
      border-color: #dbdbdb;
      &:hover {
        background-color: transparent;
      }
    }
  }
}
</style>